const TAGS_LABEL =
  "You can add up to 10 tags describing your work to help collectors discover your art. Tags must be one word each (at most 12 characters, and can only contain letters or numbers).";

export default TAGS_LABEL;
